import {Component, inject, OnInit,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {DcpOrder} from '@app/model/order/dcp-order.model';
import {OrderConfirmationPageService} from '@app/services/order/order-confirmation-page.service';
import {PxSurveyService} from '@app/services/px-survey/px-survey.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Observable} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {TranslatePipe} from '@spartacus/core';

@UntilDestroy()
@Component({
  selector: 'dcp-order-confirmation-order-info',
  templateUrl: './order-confirmation-order-info.component.html',
  imports: [AsyncPipe, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrderConfirmationOrderInfoComponent implements OnInit {
  private orderConfirmationPageService = inject(OrderConfirmationPageService);
  private pxSurveyService = inject(PxSurveyService);

  public order$: Observable<DcpOrder> = this.orderConfirmationPageService.getOrderDetails$();

  public ngOnInit(): void {
    this.pxSurveyService
      .shouldEnablePxSurvey(UNLEASH_TOGGLES.pxInstantPushSurveyEnabled)
      .pipe(untilDestroyed(this))
      .subscribe((isEnabled) => {
        if (isEnabled) {
          this.pxSurveyService.pushCheckoutSurvey({});
        }
      });
  }
}
